import { useQuery } from "@tanstack/react-query";
import { callWithAuth, getAllCourses, getCurrentCourse, getAllCoursesProgress } from "@/api/Api";
import { CourseLevel } from "@shared_types";

export interface DisplayCourse {
  id: number;
  courseId: number;
  name: string;
  title: string;
  description: string;
  level: CourseLevel;
  icon: React.ReactNode;
  progress: number;
  isCurrent: boolean;
  topic: string;
  totalChapters: number;
}

export function useCourses() {
  const { data: coursesData, isLoading: isCoursesLoading } = useQuery({
    queryKey: ["courses"],
    queryFn: () => callWithAuth(getAllCourses),
  });

  const { data: coursesProgressData, isLoading: isCoursesProgressLoading } = useQuery({
    queryKey: ["coursesProgress"],
    queryFn: () => callWithAuth(getAllCoursesProgress),
  });

  const { data: currentCourseData, isLoading: isCurrentCourseLoading } = useQuery({
    queryKey: ["currentCourse"],
    queryFn: () => callWithAuth(getCurrentCourse),
  });

  return {
    coursesData,
    currentCourseData,
    isCoursesLoading,
    isCurrentCourseLoading,
    coursesProgressData,
    isCoursesProgressLoading,
  };
} 